import {
  AUTH_SUCCESS,
  INIT_SUCCESS,
  AUTH_FAIL,
  LOGIN_FAIL,
  LOGOUT_SUCCESS,
  ADMIN_USER_LOGIN_SUCCESS
} from '../constant/actionType';
import { SESSION_ID } from '../constant';
import logger from '../util/logger';

const initialiseSessionFromLocalStorage = () => {
  return localStorage.getItem(SESSION_ID);
};

export const initialState = {
  isInitialised: false,
  mdelloAdminUser: null,
  mdelloAdminUserSessionId: null,
  sessionId: initialiseSessionFromLocalStorage(),
  showError: false,
  user: null
};

const loginReducer = (state = initialState, { type, data }) => {
  switch (type) {
    case AUTH_SUCCESS: {
      logger.debug(`${AUTH_SUCCESS}: ${JSON.stringify(data)}`);

      const { user, sessionId } = data;
      return { ...state, sessionId, showError: false, user };
    }

    case INIT_SUCCESS: {
      logger.debug(`${INIT_SUCCESS}: ${JSON.stringify(data)}`);

      const { user } = data;
      return { ...state, isInitialised: true, user };
    }

    case AUTH_FAIL: {
      return {
        ...state,
        isAuthenticated: false,
        isInitialised: true
      };
    }

    case LOGIN_FAIL: {
      return {
        ...state,
        isAuthenticated: false,
        isInitialised: true,
        showError: true
      };
    }
    case LOGOUT_SUCCESS: {
      return {
        ...state,
        isAuthenticated: false,
        isInitialised: true,
        showError: false,
        user: null
      };
    }
    case ADMIN_USER_LOGIN_SUCCESS: {
      return {
        ...state,
        mdelloAdminUser: data.user,
        mdelloAdminUserSessionId: data.sessionId
      };
    }

    default:
      return state;
  }
};

export default loginReducer;
